import {HTTP_REQUEST_AUTH} from "./requestAxios";
import {SETTING} from "@/constants/endPoints";

export const CreateSystemInfo = (params) => HTTP_REQUEST_AUTH.post(SETTING.CREATE_SYSTEM_INFO, params);
export const GetSystemInfo = (payload) => HTTP_REQUEST_AUTH.get(SETTING.GET_SYSTEM_INFO,{params:payload})
export const DeleteSystemInfo = (id)=> HTTP_REQUEST_AUTH.delete(SETTING.DELETE_SYSTEM_INFO+'/'+id);
export const UpdateSystemInfo = (id,params)=> HTTP_REQUEST_AUTH.put(SETTING.UPDATE_SYSTEM_INFO+'/'+id,params);